export const TENANT_SETTINGS_CURRENT_VALUES = ` 
query tenantSettingsCurrentValues(
  $filter: FilterTenantSettingCurrentValueInput,
    $orderBy:  TenantSettingOrderInput,
    $searchText: String,
    $skip: Int,
    $take: Int
  ){
    tenantSettingsCurrentValues(
      filter: $filter
      orderBy: $orderBy
      searchText:$searchText      
      skip: $skip
      take: $take
    ) {
      __typename
      ... on TenantSettingCurrentValue{
        id
        tenant_setting_id
        status
        value
        tenant_setting{
            id
            name
            description
          	default_value
          	setting_type_id
          	setting_type{
              id
              name
              description
            }
        	}
      	}
      ... on ResultError{
        status_code
        message
      }
    }
  }`;

export const GET_TENANT_SETTINGS = `
query tenantSettings {
  tenantSettings {
    __typename
    ... on TenantSetting {
      id
      name
      description
      default_value
      setting_type_id
      is_private
      setting_type {
        id
        name
        description
      }
    }
    ... on ResultError {
      status_code
      message
    }
  }
}`;

export const TENANT_SETTING_CURRENT_VALUE = `
query tenantSettingCurrentValue(
  $tenant_id: Int!,
  $name: String!
) {
  tenantSettingCurrentValue(tenant_id: $tenant_id, name: $name) {
    __typename
    ... on TenantSettingCurrentValue {
      value
    }

    ... on ResultError{
      status_code
      message
    }
  }
}
`;
